import { ApolloClient } from '@apollo/client';

import {
  GeneratedGetPrivateLinkQuery,
  GeneratedGetPrivateLinkWithProductsQuery,
  GeneratedPrivateLink,
  GetPrivateLinkDocument,
  GetPrivateLinkWithProductsDocument,
} from '../../../types/generated';
import { AnalyticsEmitter } from '../../../utils/analytics/emitter';
import { captureError } from '../../../utils/capture';
import {
  GetPrivateLinkResponse,
  GetPrivateLinkWithProductsResponse,
  PrivateSalesGateway,
} from '../types/PrivateLink';

export class AvantArtePrivateSalesGateway implements PrivateSalesGateway {
  // eslint-disable-next-line no-useless-constructor
  constructor(private client: ApolloClient<any>) {}

  public async getPrivateLinkWithProducts(
    slug: string,
    password?: string,
    analyticsEmitter?: AnalyticsEmitter,
  ): Promise<GetPrivateLinkWithProductsResponse> {
    try {
      analyticsEmitter?.('verify code', 'submit');

      const { data } =
        await this.client.query<GeneratedGetPrivateLinkWithProductsQuery>({
          query: GetPrivateLinkWithProductsDocument,
          fetchPolicy: 'no-cache',
          variables: { slug, password },
        });

      if (data) {
        analyticsEmitter?.('verify code', 'success');

        return {
          privateLink: data.unstable__privateLink as GeneratedPrivateLink,
        };
      }
    } catch (error) {
      analyticsEmitter?.('verify code', 'failure', { error });
      captureError(error);
    }

    return { privateLink: void 0 };
  }

  public async getPrivateLink(slug: string): Promise<GetPrivateLinkResponse> {
    try {
      const { data } = await this.client.query<GeneratedGetPrivateLinkQuery>({
        query: GetPrivateLinkDocument,
        fetchPolicy: 'no-cache',
        variables: { slug },
      });

      if (!data) {
        return { privateLink: void 0 };
      }

      return { privateLink: data.unstable__privateLink };
    } catch {
      return { privateLink: void 0 };
    }
  }
}
